// Generated by purs version 0.15.0
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Cart_State_StoredProductKey from "../Restaumatic.Cart.State.StoredProductKey/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
var StoredPromotionalItem = function (x) {
    return x;
};
var unwrapProductItemKey = function (v) {
    return v.product;
};
var storeItem = function (v) {
    return {
        promotionId: Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId(v),
        selection: v.selection,
        assignment: Data_Functor.map(Restaumatic_PromotionsEngine_Cart_PromotionalItem.functorPromotionalItemAssignment)(Restaumatic_Cart_State_StoredProductKey.toStoredProductKey)(v.assignment),
        source: Data_Functor.map(Restaumatic_PromotionsEngine_Cart_PromotionalItem.functorPromotionalItemSource)(Restaumatic_Cart_State_StoredProductKey.toStoredProductKey)(v.source),
        input: v.input
    };
};
var storePromotionalItems = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray)(storeItem);
var isValidAssignment = function (v) {
    return function (v1) {
        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.TargetCart && v1 instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.UnassignmentToCart) {
            return true;
        };
        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.TargetCart && v1 instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToCart) {
            return true;
        };
        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.TargetProductItems && v1 instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.UnassignmentToProduct) {
            return true;
        };
        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.TargetProductItems && v1 instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToProduct) {
            return Data_Foldable.elem(Data_Set.foldableSet)(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(Restaumatic_Cart_ProductKey.eqProductKey))(v1.value0)(v.value0);
        };
        return false;
    };
};
var updateItem = function (v) {
    return function (v1) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_Alternative.guard(Data_Maybe.alternativeMaybe)(Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId)(v.promotionId)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId(v1))))(function () {
            var source = Data_Functor.map(Restaumatic_PromotionsEngine_Cart_PromotionalItem.functorPromotionalItemSource)(Restaumatic_Cart_State_StoredProductKey.fromStoredProductKey)(v.source);
            var assignment = Data_Functor.map(Restaumatic_PromotionsEngine_Cart_PromotionalItem.functorPromotionalItemAssignment)(Restaumatic_Cart_State_StoredProductKey.fromStoredProductKey)(v.assignment);
            return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_Alternative.guard(Data_Maybe.alternativeMaybe)(isValidAssignment(v1.target)(assignment)))(function () {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                    promotionalItemId: v1.promotionalItemId,
                    promotion: v1.promotion,
                    target: v1.target,
                    source: source,
                    assignment: assignment,
                    selection: v.selection,
                    input: v.input,
                    value: v1.value,
                    active: v1.active
                });
            });
        });
    };
};
var restorePromotionalItemAssignments = function (storedItems) {
    return function (engineItems) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_Alternative.guard(Data_Maybe.alternativeMaybe)(Data_Array.length(storedItems) === Data_Array.length(engineItems)))(function () {
            return Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(Data_Array.zipWith(updateItem)(storedItems)(engineItems));
        });
    };
};
var genericStoredPromotionalItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStoredPromotionalItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStoredPromotionalItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "input";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "source";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.showPromotionalItemSource(Restaumatic_Cart_State_StoredProductKey.showStoredProductKey)))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.showSelectionStatus))(Restaumatic_Promotions_Types_Id.showPromotionId))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.showPromotionalItemInput))(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.showPromotionalItemAssignment(Restaumatic_Cart_State_StoredProductKey.showStoredProductKey)))))({
        reflectSymbol: function () {
            return "StoredPromotionalItem";
        }
    }))
};
var eqStoredPromotionalItem = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericStoredPromotionalItem)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItemSource(Restaumatic_Cart_State_StoredProductKey.eqStoredProductKey)))()({
        reflectSymbol: function () {
            return "selection";
        }
    })(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqSelectionStatus))()({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Restaumatic_Promotions_Types_Id.eqPromotionId))()({
        reflectSymbol: function () {
            return "input";
        }
    })(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItemInput))()({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItemAssignment(Restaumatic_Cart_State_StoredProductKey.eqStoredProductKey))))))
};
var encodeStoredPromotionalItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericStoredPromotionalItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "StoredPromotionalItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.encodePromotionalItemSource(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_ProductItem.encodeProductItemKey(Restaumatic_Cart_State_StoredProductKey.encodeStoredProductKey)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Cart_State_StoredProductKey.encodeStoredProductKey))))))({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Cart_PromotionalItem.encodeSelectionStatus)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))({
        reflectSymbol: function () {
            return "input";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PromotionsEngine_Cart_PromotionalItem.encodePromotionalItemInput)))({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.encodePromotionalItemAssignment(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_ProductItem.encodeProductItemKey(Restaumatic_Cart_State_StoredProductKey.encodeStoredProductKey)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Cart_State_StoredProductKey.encodeStoredProductKey)))))))))
};
var decodeStoredPromotionalItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericStoredPromotionalItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "StoredPromotionalItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.decodePromotionalItemSource(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_ProductItem.decodeProductItemKey(Restaumatic_Cart_State_StoredProductKey.decodeStoredProductKey)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Cart_State_StoredProductKey.decodeStoredProductKey)))))())({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Cart_PromotionalItem.decodeSelectionStatus))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId))())({
        reflectSymbol: function () {
            return "input";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_PromotionsEngine_Cart_PromotionalItem.decodePromotionalItemInput))())({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_PromotionalItem.decodePromotionalItemAssignment(/* #__PURE__ */ Restaumatic_PromotionsEngine_Cart_ProductItem.decodeProductItemKey(Restaumatic_Cart_State_StoredProductKey.decodeStoredProductKey)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Cart_State_StoredProductKey.decodeStoredProductKey)))))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    StoredPromotionalItem,
    storePromotionalItems,
    restorePromotionalItemAssignments,
    genericStoredPromotionalItem,
    showStoredPromotionalItem,
    eqStoredPromotionalItem,
    decodeStoredPromotionalItem,
    encodeStoredPromotionalItem
};
//# sourceMappingURL=index.js.map
